import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { DynoFormModal } from 'components/dyno-template/modals';

import { MODAL_FULLSCREEN_SIZE } from 'settings/constants/ui-control';
import { SWIFT_LLD_FIELDS } from 'settings/constants/transfer/swift/form';
import { useIntl } from 'react-intl';

const LldForm = ({ isOpen, onClose, onChange, onSubmit, formDetail, dynamicFields }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const fullScreen = useMediaQuery(theme.breakpoints.down(MODAL_FULLSCREEN_SIZE));

  return (
    <DynoFormModal
      hasNoteContent={false}
      fullScreen={fullScreen}
      onSubmit={onSubmit}
      isOpen={isOpen}
      onClose={onClose}
      formDetail={formDetail}
      onChange={onChange}
      fields={SWIFT_LLD_FIELDS(formatMessage)}
      dynamicFields={dynamicFields}
      title="transaction.transfer.swift.modal.name"
    />
  );
};

LldForm.defaultProps = { dynamicFields: [] };

LldForm.propTypes = {
  dynamicFields: PropTypes.array,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formDetail: PropTypes.object.isRequired,
  // title: PropTypes.string.isRequired,
};

export default LldForm;
